export const MIN_TIME_VALUE = 0;
export const MIN_DATE_VALUE = 1;
export const MAX_HOURS_VALUE = 23;
export const MAX_MINUTES_VALUE = 59;
export const MAX_YEARS_VALUE = 9999;
export const MAX_MONTH_VALUE = 12;
export const MAX_DAYS_VALUE = 31;

export const splitDateTime = (value: string): { date: string; time: string } => {
  // Accept "YYYY-MM-DDTHH:mm"
  const [date = '', time = '00:00'] = value.split('T');
  return { date, time };
};

export const combineDateTime = (date: string, time: string): string => {
  if (!date || !time) return '';
  return `${date}T${time}`;
};

export const restrictNumberToTimeValue = (n: number, min: number, max: number): number => {
  return Math.max(min, Math.min(max, n));
};

export const padTo = (n: number, padTo: number = 2): string => {
  return String(n).padStart(padTo, '0');
};

export const parseHoursMinutes = (value: string): [number, number] => {
  const [h = '0', m = '0'] = value.split(':');
  return [Number(h), Number(m)];
};

export const parseDateTime = (
  value?: string | null // "YYYY-MM-DDTHH:mm"
): { month?: number; day?: number; year?: number; hour: number; minute: number } => {
  if (!value) {
    return { hour: 0, minute: 0 };
  }
  const [dPart, tPart = '00:00'] = value.split('T');
  const [yyyy, mm, dd] = dPart.split('-').map(Number);
  const [hh, mi] = tPart.split(':').map(Number);

  return {
    day: dd || undefined,
    month: mm || undefined,
    year: yyyy || undefined,
    hour: hh || 0,
    minute: mi || 0,
  };
};

export const daysInMonth = (month: number, year: number): number => new Date(year, month, 0).getDate();

export const isNumeric = (value: unknown): boolean => typeof value === 'number';
